export default __webpack_public_path__ + "static/media/vlcsnap-2020-05-08-15h41m54s058.610b0188.png";